export default __webpack_public_path__ + "static/TSD_How_we_work_Megaphone-00868361580e6b6b821f92c69d0ae031.png";